import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { debounce, find } from 'lodash';
import SupportArticle from './SupportArticle';
import Loader from '../Loader/Loader';
import PageHeader from '../PageHeader/PageHeader';
import DomUtilities from '../../common/DomUtilities';
import './Support.scss';

const SCROLL_DELAY_MILLIS = 350;

const formatPath = (isArticleSelected, path, id) => {
  const [, basePath, category] = path.split('/');

  return isArticleSelected
    ? `/${basePath}/${category}`
    : `/${basePath}/${category}/${id}`;
};

class SupportArticles extends React.PureComponent {
  constructor() {
    super();

    this.elements = {};
    this.scrollIntoView = debounce((element) => {
      DomUtilities.scrollElementIntoView(element);
    }, SCROLL_DELAY_MILLIS);
  }

  componentWillMount() {
    const { articles, articlesPending } = this.props;

    if (!articles && !articlesPending) {
      this.props.fetchArticles();
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentDidUpdate() {
    const { selectedArticle, articles } = this.props;

    if (selectedArticle && find(articles, article => article.id === selectedArticle)) {
      this.scrollIntoView(this.elements[selectedArticle]);
    }
  }

  render() {
    const { title, articles, articlesPending, path, selectedArticle } = this.props;

    return (
      <main>
        <PageHeader
          title={title}
        />
        <div className="container support">
          {articlesPending && <Loader height={'75px'} />}
          <ul>
            {articles && articles.map((article) => {
              const isArticleSelected = selectedArticle === article.id;
              const link = formatPath(isArticleSelected, path, article.id);

              return (
                <li key={article.id} ref={(ref) => { this.elements[article.id] = ref; }}>
                  <SupportArticle
                    id={article.id}
                    question={article.question}
                    answer={article.answer}
                    shouldShow={isArticleSelected}
                    link={link}
                  />
                </li>
              );
            })}
          </ul>
          <Link to={'/support-centre'} className={'btn btn-default support-btn support-articles-button'}>BACK</Link>
        </div>
      </main>
    );
  }
}

SupportArticles.propTypes = {
  title: PropTypes.string,
  articles: PropTypes.arrayOf(PropTypes.object),
  articlesPending: PropTypes.bool,
  path: PropTypes.string,
  selectedArticle: PropTypes.string,
  fetchArticles: PropTypes.func
  // fetchSubArticles: PropTypes.func
};

export default SupportArticles;



/** WEBPACK FOOTER **
 ** ./src/components/Support/SupportArticles.js
 **/